export enum SubscriptionTypes {
  SelfServe = 'self_serve',
  SemiPro = 'semi_pro',
  Pro = 'pro',
  ProTrial = 'pro_trial',
  SemiProTrial = 'semi_pro_trial',
  Custom = 'custom',
}
